import { render, staticRenderFns } from "./PRO_DxSummary.vue?vue&type=template&id=7f6c6efa&scoped=true&"
import script from "./PRO_DxSummary.vue?vue&type=script&lang=js&"
export * from "./PRO_DxSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6c6efa",
  null
  
)

export default component.exports